import registrationStep from "../../registrationStep";
import IDPage from "./IDPage";

export default registrationStep(IDPage, "id", "questionnaire/0");



// WEBPACK FOOTER //
// ./src/registration/components/ID/index.js